var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSmsSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26448",
    "data-name": "Group 26448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26443",
    "data-name": "Group 26443",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M673.26,400.34h-12a2,2,0,0,1-2-2v-8.83a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v8.83A2,2,0,0,1,673.26,400.34Zm-7.5-3.14h0a2.73,2.73,0,0,0,.72.32l.27.79a.26.26,0,0,0,.23.18h1.08a.3.3,0,0,0,.23-.18l.26-.79a2.8,2.8,0,0,0,.73-.32l.73.38.11,0a.22.22,0,0,0,.18-.08l.76-.75a.23.23,0,0,0,.05-.3l-.37-.72a3.94,3.94,0,0,0,.32-.73l.78-.26a.28.28,0,0,0,.18-.24v-1.07a.27.27,0,0,0-.17-.24l-.79-.26a3.94,3.94,0,0,0-.32-.73l.37-.72a.26.26,0,0,0-.05-.32l-.76-.73a.2.2,0,0,0-.17-.09.24.24,0,0,0-.12,0l-.73.38a2.8,2.8,0,0,0-.73-.32l-.26-.79a.25.25,0,0,0-.23-.17H667a.21.21,0,0,0-.23.17l-.26.79a2.8,2.8,0,0,0-.73.32l-.73-.38-.12,0a.25.25,0,0,0-.2.09l-.73.72a.28.28,0,0,0-.06.32l.38.73a3.94,3.94,0,0,0-.32.73l-.79.26a.22.22,0,0,0-.17.23v1.08a.25.25,0,0,0,.17.24l.79.26a3.94,3.94,0,0,0,.32.73l-.38.73a.22.22,0,0,0,.06.29l.73.75a.25.25,0,0,0,.2.09.27.27,0,0,0,.12,0Zm1.75-.58a2.64,2.64,0,1,1,2.65-2.65,2.64,2.64,0,0,1-2.65,2.65Z",
    transform: "translate(-659.26 -387.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46845",
    "data-name": "Path 46845",
    d: "M668.19,400.08l-3.3,3.43v-3.43Z",
    transform: "translate(-659.26 -387.51)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSmsSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_smsSettings.6a704762d2bd2da3173ade113178a44c.svg";